export { LodControl } from './lod-control';
export type { LodControlProps } from './lod-control';
